import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncEventAttendance({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/eventAttendance"));
  console.log("Loading", AsyncEventAttendance.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncEventAttendance;
